import Swal from 'sweetalert2'
import AxiosConfig from '@/config/axios-config'

export const ResponseUtils = {

  getErrorData: error => {
    if (error && error.response && error.response.data) {
      return error.response.data
    }
  },

  handleError: (error, loader) => {
    if (!AxiosConfig.isCancelled(error)) {
      let message = 'Ocorreu um erro inesperado, por favor entre em contato com o administrador do sistema.'
      if (error.response && error.response.data) {
        const data = error.response.data

        if (data.mensagem) {
          message = data.mensagem
        } else if (data.error && data.error.message) {
          message = data.error.message
        } else if (data.errors) {
          const errors = Object.keys(data.errors)
          if (errors.length) {
            const errors = Object.keys(data.errors)
            message = errors.reduce((result, key) => result + data.errors[key], '')
          }
        }
      }

      if (loader) {
        loader.hide()
      }

      Swal.fire({
        icon: 'error',
        html: message
      })
    }
  },

  handleSuccess: (callback, loader) => {
    callback()
    if (loader) loader.hide()
  }

}

export default ResponseUtils
